import { render, staticRenderFns } from "./WSurveyAnswerView.vue?vue&type=template&id=63ba1c22&"
import script from "./WSurveyAnswerView.vue?vue&type=script&lang=ts&"
export * from "./WSurveyAnswerView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports